import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

// Reach localizes prices in span.money
export const Price = styled(TypeStyle.HeadlineExtraExtraSmall).attrs({
  className: 'money',
})<{ $isSalePrice?: boolean; $displayDiscountAsValue?: boolean }>`
  align-items: center;
  color: ${o =>
    o.$isSalePrice && !o.$displayDiscountAsValue
      ? o.theme.color.text.critical.on.background
      : o.theme.color.text.primary.on.background};
  display: flex;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
`

export const PriceRow = styled.span`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: ${o => o.theme.spacing(2)};
`

export const FullPrice = styled(Price)`
  color: ${o => o.theme.color.text.tertiary.on.background};
  text-decoration: line-through;
`

export const ValuePrice = styled(Price)`
  color: ${o => o.theme.color.text.tertiary.on.background};
`

export const DeleteIconColumn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-inline-start: 6px;

  ${fromMd} {
    margin-inline-start: 12px;
  }
`

export const DeleteIconButton = styled.button`
  display: flex;
  background: unset;
  border: unset;
  cursor: pointer;
  padding: 0;
`
